import { render, staticRenderFns } from "./AttachmentLookupsManagement.vue?vue&type=template&id=aa26a984"
import script from "./AttachmentLookupsManagement.vue?vue&type=script&lang=js"
export * from "./AttachmentLookupsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports